import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./HelpCenter.module.css";
import { MdOutlineNotStarted } from "react-icons/md";
import { IoSettingsOutline } from "react-icons/io5";
import { LuBrain } from "react-icons/lu";
  import { HiPlayPause } from "react-icons/hi2";

import helpImage from "../../Images/CHATBOT.gif"
import women from "../../Images/woman.gif";
import TicketPopup from "./TicketPopup";

const HelpCenter = () => {
  const [isTicketPopupOpen, setIsTicketPopupOpen] = useState(false);
  const navigate = useNavigate();
  const handleShowTickets =async()=>{
    navigate("/show-ticket")
  }
  const handleOpenTicketPopup = () => {
    setIsTicketPopupOpen(true);
  };

  const handleCloseTicketPopup = () => {
    setIsTicketPopupOpen(false);
  };
  return (
    <div className={styles.helpCenter}>
      <section className={styles.heroSection}>
        <div className={styles.illustrationContainer}>
        <div className={styles.illustrationText}>
        <h1>Let’s solve it together. <br />What do you need?</h1>
        <input
          type="text"
          placeholder="Let's search ToxBox Help Center to get you what you need"
          className={styles.searchBox}
        />
        </div>
        <div className={styles.illustration}>
          <img src={helpImage} />
        </div>
        </div>
      </section>

      <div  className={styles.cardSection}>
        <button className={styles.exploreButton} onClick={()=> navigate('/toxboxSection')}><HiPlayPause /> EXPLORE</button>
      </div>

      <section className={styles.cardSection}>
        <div className={styles.card}>
        <span><MdOutlineNotStarted /></span>
        Getting Started
        </div>
        <div className={styles.card}>
        <span><IoSettingsOutline /></span>
        AI Assistant Features
        </div>
        <div className={styles.card}>
        <span><LuBrain /></span>
        Dashboard & Settings
        </div>
        <div className={styles.card}>
        <span><MdOutlineNotStarted /></span>
        Billing & Subscription
        </div>
      </section>

      <section className={styles.supportSection}>
        <div className={styles.supportLeft}>
          <h3>Need personal assistance?</h3>
          <p>
            Still have questions? We've got your back! Reach out to our support
            team by submitting a ticket — we’ll be with you shortly.
          </p>
          <button className={styles.submitButton} onClick={handleOpenTicketPopup}>Create ticket</button>
           
           
        </div>
        <div className={styles.supportRight}>
          <img src={women} alt="Support" />
        </div>
      </section>


      <section  className={styles.raisedTicketsSection}>
              <h3>Get Your all tickets raised</h3>
          <button className={styles.submitButton} onClick={handleShowTickets}>
            Raised tickets</button>
      </section>

      <section className={styles.bottomHelp}>
        <h3>Still have questions?</h3>
        <p>
          Our team is ready to assist you via live chat or phone.
          <br />
          We're here to help anytime.
        </p>
        <div className={styles.contactOptions}>
          <div className={styles.contactCard}>
            <h4>Chat with us</h4>
            <p>Connect with our support team instantly. Get real-time answers to your questions.</p>
            <a href="#">Chat now</a>
          </div>
          <div className={styles.contactCard}>
            <h4>Contact us</h4>
            <p>Reach out to us anytime. We’re here to help with your questions or issues.</p>
            <a href="#">Call now</a>
          </div>
        </div>
      </section>

      <footer className={styles.footer}>
        <p>© 2025 ToxBox, All Rights Reserved</p>
        <div>
          <a href="#">Privacy policy</a> | <a href="#">Terms of service</a>
        </div>
      </footer>
      
      {/* Ticket Popup */}
      <TicketPopup 
        isOpen={isTicketPopupOpen} 
        onClose={handleCloseTicketPopup} 
      />
    </div>
  );
};

export default HelpCenter;
